import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash";

export default class extends Controller {
  static targets = ["slider", "button", "items"];

  PADDING_SIZE = 10;
  ACTIVE_BUTTON_CLASS = "bg-primary-500";
  INACTIVE_BUTTON_CLASS = "bg-neutral-550";
  DEBOUNCE_DELAY = 200;

  declare buttonTargets: Array<HTMLButtonElement>;
  declare sliderTarget: HTMLElement;

  moveSlide(event: Event) {
    const target = event.target as HTMLButtonElement;
    const scrollTo = Number(target.dataset.index) * this.getScrollToValue();

    this.sliderTarget.scrollTo({ left: scrollTo, behavior: "smooth" });

    this.removeAllActiveClasses();

    this.addActiveClass(target);
  }

  addActiveClass(target: HTMLButtonElement) {
    target.classList.add(this.ACTIVE_BUTTON_CLASS);
    target.classList.remove(this.INACTIVE_BUTTON_CLASS);
  }

  initialize() {
    this.sliderTarget.addEventListener(
      "scroll",
      debounce(this.updateNavigation.bind(this), 100)
    );
  }

  updateNavigation() {
    const button = this.getActiveButton();

    this.removeAllActiveClasses();
    this.addActiveClass(button);
  }

  removeAllActiveClasses() {
    this.buttonTargets.forEach((button) => {
      button.classList.add(this.INACTIVE_BUTTON_CLASS);
      button.classList.remove(this.ACTIVE_BUTTON_CLASS);
    });
  }

  getActiveButton(): HTMLButtonElement {
    return this.buttonTargets.find(
      (button) => button.dataset.index === String(this.getActiveSlide())
    );
  }

  getActiveSlide(): number {
    return Math.round(
      this.sliderTarget.scrollLeft /
        (this.sliderTarget.clientWidth -
          parseInt(getComputedStyle(this.sliderTarget).paddingLeft, 10) -
          parseInt(getComputedStyle(this.sliderTarget).paddingRight, 10) +
          parseInt(getComputedStyle(this.sliderTarget).columnGap, 10))
    );
  }

  getScrollToValue(): number {
    return (
      this.sliderTarget.clientWidth -
      parseInt(
        getComputedStyle(this.sliderTarget).paddingLeft,
        this.PADDING_SIZE
      ) -
      parseInt(
        getComputedStyle(this.sliderTarget).paddingRight,
        this.PADDING_SIZE
      ) +
      parseInt(getComputedStyle(this.sliderTarget).columnGap, this.PADDING_SIZE)
    );
  }
}
